import { useQuery } from "react-query";
import queryKeys from "../../constants/queryKeys";
import caseNestService from "../../services/caseNestService";

const useUserRoles = () => useQuery([queryKeys.userRoles], () => caseNestService.fetchUserRoles());

export default useUserRoles;
